import { Link, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import ButtonWhatsapp from "../components/ButtonWhatsapp";
import { Image } from "antd";
import Footer from "../components/Footer";

export default function AboutUs() {

    const { pathname } = useLocation();
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    const [visible, setVisible] = useState(false);
  
    const openPreview = () => {
      setVisible(true); // Abrimos el preview
    };
  
  
   
  
   
    return (
        <div>

  

<div className="container-fluid topbar bg-secondary d-none d-xl-block w-100">
        <div className="container">
          <div
            className="row gx-0 align-items-center"
            style={{ height: "45px" }}
          >
            <div className="col-lg-6 text-center text-lg-start mb-lg-0">
              <div className="d-flex flex-wrap">
                <a  href="https://www.google.com/maps?q=Batalla+de+Puebla,+1ro+de+Mayo,+23406+San+José+del+Cabo,+B.C.S.,+México" className="text-muted me-4"
                
                  target="_blank"
                        rel="noopener noreferrer"
                >
                  <i className="fas fa-map-marker-alt text-primary me-2"></i>
                  Our location
                </a>
                <a href="tel:+5216242302304" className="text-muted me-4"
                     target="_blank" 
                   rel="noopener noreferrer"
                >
                  <i className="fas fa-phone-alt text-primary me-2"></i>
                  +5216242302304
                </a>
                <a href="mailto:reservations@tigresstransport.com.mx" className="text-muted me-0"
                     target="_blank" 
                   rel="noopener noreferrer"
                >
                  <i className="fas fa-envelope text-primary me-2"></i>
                  reservations@tigresstransport.com.mx
                </a>
              </div>
            </div>
            <div className="col-lg-6 text-center text-lg-end">
              <div className="d-flex align-items-center justify-content-end">
                <a
                  href="https://www.facebook.com/profile.php?id=100091411777035"
                  className="btn btn-light btn-sm-square rounded-circle me-3"
                   target="_blank" 
                   rel="noopener noreferrer"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
{/*                 <a
                  href="#"
                  className="btn btn-light btn-sm-square rounded-circle me-3"
                >
                  <i className="fab fa-twitter"></i>
                </a>
                <a
                  href="#"
                  className="btn btn-light btn-sm-square rounded-circle me-3"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a
                  href="#"
                  className="btn btn-light btn-sm-square rounded-circle me-0"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </div>


         <div class="container-fluid nav-bar sticky-top px-0 px-lg-4 py-2 py-lg-0">
            <div class="container">
            <nav className="navbar navbar-expand-lg navbar-light">
                  <Link to="/" className="navbar-brand p-0">
                    <img src="img/Logo.jpg" alt="Logo" />
                  </Link>
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarCollapse"
                  >
                    <span className="fa fa-bars"></span>
                  </button>
      
                  <div className="collapse navbar-collapse" id="navbarCollapse">
                    <div className="navbar-nav mx-auto py-0">
                      <Link to="/" className="nav-item nav-link  ">
                        Home
                      </Link>
                      <div className="nav-item dropdown">
                        <Link
                          href="#"
                          className="nav-link dropdown-toggle active"
                          data-bs-toggle="dropdown"
                        >
                          About us
                        </Link>
                        <div className="dropdown-menu m-0">
                        <Link to="/about-us" className="dropdown-item active">
                           About us
                          </Link> 
      
                          <Link
                            to="/private-transportation"
                            className="dropdown-item"
                          >
                            Private Transportation
                          </Link>
                       {/*    <Link to="/shared-shuttle" className="dropdown-item">
                            Shared Shutttle
                          </Link> */}
                          <Link to="/large-groups" className="dropdown-item ">
                            Large Groups
                          </Link>
      
                          <Link to="/gallery" className="dropdown-item">
                            Gallery
                          </Link>
                        </div>
                      </div>
                      <Link to="/destinations" className="nav-item nav-link ">
                        Destinations
                      </Link>
                      <Link to="/vehicles" className="nav-item nav-link">
                        Our Fleet
                      </Link>
                      <Link to="/reviews" className="nav-item nav-link">
                        Our Reviews
                      </Link>
                      <Link to="/contact-us" className="nav-item nav-link active">
                      Contact Us
                      </Link>
                    
                   
                    </div>
                    <Link
                      to="/book-now"
                      className="btn btn-primary rounded-pill py-2 px-4"
                    >
                      Book Now
                    </Link>
                  </div>
                </nav>
            </div>
        </div>

        <div class="container-fluid bg-breadcrumb">
            <div class="container text-center py-5" style={{maxWidth: "900px"}}>
                <h4 class="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">About Us</h4>
               
            </div>
        </div>
        <div class="container-fluid overflow-hidden about ">
  <div class="container py-5">
    <div class="row g-5">
      <div class="col-xl-6 wow fadeInLeft" data-wow-delay="0.2s">
        <div class="about-item">
          <div class="pb-5">
            <h1 class="display-5 text-capitalize">About Us</h1>
            <p class="mb-0">
              At Tigress Transport, we are proud to offer premium transportation services in Baja California and surrounding areas, including San José del Cabo. With a focus on comfort, reliability, and customer satisfaction, we aim to make every journey unforgettable.
            </p>
          </div>
          <div class="row g-4">
            <div class="col-lg-6">
              <div class="about-item-inner border p-4">
                <div class="about-icon mb-4">
                  <img src="img/about-icon-1.png" class="img-fluid w-50 h-50" alt="Icon" />
                </div>
                <h5 class="mb-3">Our Vision</h5>
                <p class="mb-0">To become the leading transportation service in Baja California, connecting travelers with the beauty and culture of the region.</p>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="about-item-inner border p-4">
                <div class="about-icon mb-4">
                  <img src="img/about-icon-2.png" class="img-fluid h-50 w-50" alt="Icon" />
                </div>
                <h5 class="mb-3">Our Mission</h5>
                <p class="mb-0">To deliver exceptional, safe, and convenient transportation services tailored to the unique needs of our clients.</p>
              </div>
            </div>
          </div>
          <p class="text-item my-4">
            With over 17 years of experience, we have built a reputation for excellence in transportation. Whether you're exploring the vibrant streets of Baja California or relaxing in the serene beaches of San José del Cabo, Tigress Transport is here to get you there in style and comfort.
          </p>
          <div class="row g-4">
            <div class="col-lg-6">
              <div class="text-center rounded bg-secondary p-4">
                <h1 class="display-6 text-white">17</h1>
                <h5 class="text-light mb-0">Years Of Experience</h5>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="rounded">
                <p class="mb-2"><i class="fa fa-check-circle text-primary me-1"></i> Reliable transportation services</p>
                <p class="mb-2"><i class="fa fa-check-circle text-primary me-1"></i> Luxurious and comfortable rides</p>
                <p class="mb-2"><i class="fa fa-check-circle text-primary me-1"></i> Tailored solutions for your journey</p>
                <p class="mb-0"><i class="fa fa-check-circle text-primary me-1"></i> Local expertise you can trust</p>
              </div>
            </div>
        
          </div>
        </div>
      </div>
      <div class="col-xl-6 wow fadeInRight" data-wow-delay="0.2s">
        <div class="about-img">
          <div class="img-1">
            <img src={require("../img/Clientes/Cliente-5.jpg")} class="img-fluid rounded h-100 w-100" alt="" />
          </div>
  
        </div>
      </div>
    </div>
  </div>
</div>

<div className="container-fluid feature py-5">
        <div className="container py-5">
          <div
            className="text-center mx-auto pb-5 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: "800px" }}
          >
            <h1 className="display-5 text-capitalize mb-3">
              Tigress transport – Low Cost Airport Transfers
            </h1>
            <p className="mb-0">
              With our easy online reservation system, we have outdone our
              competitors just 2 clicks and your reservation is complete, we
              believe you should only have to input your reservation once. Your
              flight and hotel information is then entered into our
              sophisticated reservation system that our professionals are
              constantly monitoring.
            </p>
          </div>
          <div className="row g-4 align-items-center">
            <div className="col-xl-4">
              <div className="row gy-4 gx-0">
                <div className="col-12 wow fadeInUp" data-wow-delay="0.1s">
                  <div className="feature-item">
                    <span className="fa fa-check fa-2x"></span>

                    <div className="ms-4">
                      <h5 className="mb-3">
                        Phone Customer Service Available 24/7
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-12 wow fadeInUp" data-wow-delay="0.3s">
                  <div className="feature-item">
                    <span className="fa fa-check fa-2x"></span>

                    <div className="ms-4">
                      <h5 className="mb-3">
                        Unlimited changes and free cancellations
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-12 col-xl-4 wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <Image.PreviewGroup
                items={[
                  require("../img/Clientes/Selfie.jpg"),
                  require("../img/Clientes/Cliente-1.jpg"),
                  require("../img/Clientes/Cliente-2.jpg"),
                  require("../img/Clientes/Cliente-3.jpg"),
                  require("../img/Clientes/Cliente-4.jpg"),
                  require("../img/Clientes/Cliente-5.jpg"),
                  require("../img/Clientes/Cliente-6.jpg"),
                  require("../img/Clientes/Cliente-7.jpg"),
                  require("../img/Clientes/Cliente-8.jpg"),
                  require("../img/Clientes/Cliente-9.jpg"),
                  require("../img/Clientes/Cliente-10.jpg"),

                  require("../img/Clientes/Cliente-11.jpg"),

                  require("../img/Clientes/Cliente-12.jpg"),
                  require("../img/Clientes/Cliente-13.jpg"),

               


                ]}
                preview={{
                  visible: visible,
                  onVisibleChange: (value) => setVisible(value), // Cerramos el preview
                }}
              >
                <Image
                  src={require("../img/Clientes/Selfie.jpg")}
                  className="img-fluid w-100"
                  style={{ objectFit: "cover" }}
                  alt="Img"
                />
              </Image.PreviewGroup>
              <div className="col-12 py-2">
                <button
                  onClick={openPreview}
                  className="btn btn-primary w-100 py-2"
                >
                  View more
                </button>
              </div>
            </div>
            <div className="col-xl-4">
              <div className="row gy-4 gx-0">
                <div className="col-12 wow fadeInUp" data-wow-delay="0.1s">
                  <div className="feature-item justify-content-end">
                    <div className="text-end me-4">
                      <h5 className="mb-3">Grocery stops on request</h5>
                    </div>
                    <span className="fa fa-check fa-2x"></span>
                  </div>
                </div>
                <div className="col-12 wow fadeInUp" data-wow-delay="0.3s">
                  <div className="feature-item justify-content-end">
                    <div className="text-end me-4">
                      <h5 className="mb-3">Best price guarantee</h5>
                    </div>
                    <span className="fa fa-check fa-2x"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
       

      

        <div class="container-fluid steps py-5">
    <div class="container py-5">
        <div class="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.1s" style={{maxWidth: "800px"}}>
            <h1 class="display-5 text-capitalize text-white mb-3"><span class="text-primary">Tigress </span>Transport</h1>
            <p class="mb-0 text-white">At Tigress Transport, we’ve designed a simple process to ensure you enjoy a smooth and reliable travel experience across Baja California and destinations like San José del Cabo.</p>
        </div>
        <div class="row g-4">
            <div class="col-lg-4 wow fadeInUp" data-wow-delay="0.1s">
                <div class="steps-item p-4 mb-4">
                    <h4>Step 1: Contact Us</h4>
                    <p class="mb-0">Reach out to us to book your ride. Whether you’re planning ahead or need last-minute transportation, our team is ready to assist you.</p>
                    <div class="steps-number">01.</div>
                </div>
            </div>
            <div class="col-lg-4 wow fadeInUp" data-wow-delay="0.3s">
                <div class="steps-item p-4 mb-4">
                    <h4>Step 2: Choose Your Destination</h4>
                    <p class="mb-0">Let us know where you want to go. From airport pickups to exploring the beautiful scenery of Baja California, we’ve got you covered.</p>
                    <div class="steps-number">02.</div>
                </div>
            </div>
            <div class="col-lg-4 wow fadeInUp" data-wow-delay="0.5s">
                <div class="steps-item p-4 mb-4">
                    <h4>Step 3: Enjoy the Ride</h4>
                    <p class="mb-0">Sit back, relax, and let us handle the rest. With our professional drivers and comfortable vehicles, you’re guaranteed a safe and enjoyable journey.</p>
                    <div class="steps-number">03.</div>
                </div>
            </div>
        </div>
    </div>
</div>


     

      

       <Footer/>


        <ButtonWhatsapp/>


    </div>
    )
}